/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Spell_Numbers_LabelInputs */

const en_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spell #1...10`)
};

const fr_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epeler #1...10`)
};

const de_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zauber #1...10`)
};

const it_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incantesimo n. 1...10`)
};

const ru_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заклинание №1...10`)
};

const es_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hechizo #1...10`)
};

const zh_cn2_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咒语#1...10`)
};

const ja_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`呪文 #1...10`)
};

const hi_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मंत्र #1...10`)
};

const pt_pt2_style_guide_manager_spell_numbers_label = /** @type {(inputs: Style_Guide_Manager_Spell_Numbers_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feitiço nº 1...10`)
};

/**
* | output |
* | --- |
* | "Spell #1...10" |
*
* @param {Style_Guide_Manager_Spell_Numbers_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_spell_numbers_label = /** @type {((inputs?: Style_Guide_Manager_Spell_Numbers_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Spell_Numbers_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_spell_numbers_label(inputs)
	if (locale === "de") return de_style_guide_manager_spell_numbers_label(inputs)
	if (locale === "it") return it_style_guide_manager_spell_numbers_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_spell_numbers_label(inputs)
	if (locale === "es") return es_style_guide_manager_spell_numbers_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_spell_numbers_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_spell_numbers_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_spell_numbers_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_spell_numbers_label(inputs)
	return en_style_guide_manager_spell_numbers_label(inputs)
});